import React from 'react'
import PropTypes from 'prop-types'
import 'bootstrap/dist/css/bootstrap.min.css'
import Upcomingdays from '../UpcomingDaysForecast/Upcomingdays'
import CurrentDay from '../CurrentDay/CurrentDay'
import './main.css'

const Main = ({ forecast }) => {
  return (
    <div>
      <div className='forecast'>
        <div>
          <CurrentDay {...forecast.currentDay} />
        </div>
        {/* <div className='col-sm-12 col-md-6 col-lg-8 col-xl-8'>
            <div className='row'>
              <div className=' col-xs-6 col-sm-4 col-md-6 col-lg-4'>
                <Upcomingdays days={forecast.upComingDays} />
              </div>
            </div>
          </div> */}
      </div>
    </div>
  )
}

Main.propTypes = {
  forecast: PropTypes.shape({
    currentDay: PropTypes.object,
    upComingDays: PropTypes.array,
  }),
}

export default Main
